import { render, staticRenderFns } from "./App.vue?vue&type=template&id=16b23171&scoped=true"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"
import style0 from "./style.scss?vue&type=style&index=0&id=16b23171&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16b23171",
  null
  
)

export default component.exports